const SKELETON = `
<div style="animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;">
  <div style="display:grid;grid-template-columns:1fr 1fr;gap:1rem;margin-bottom:1.5rem;">
    <div><div style="height:0.75rem;width:3rem;background:#e5e7eb;border-radius:0.25rem;margin-bottom:0.5rem;"></div><div style="height:1rem;width:10rem;background:#e5e7eb;border-radius:0.25rem;"></div></div>
    <div><div style="height:0.75rem;width:4rem;background:#e5e7eb;border-radius:0.25rem;margin-bottom:0.5rem;"></div><div style="height:1rem;width:6rem;background:#e5e7eb;border-radius:0.25rem;"></div></div>
    <div><div style="height:0.75rem;width:5rem;background:#e5e7eb;border-radius:0.25rem;margin-bottom:0.5rem;"></div><div style="height:1rem;width:8rem;background:#e5e7eb;border-radius:0.25rem;"></div></div>
    <div><div style="height:0.75rem;width:3rem;background:#e5e7eb;border-radius:0.25rem;margin-bottom:0.5rem;"></div><div style="height:1rem;width:5rem;background:#e5e7eb;border-radius:0.25rem;"></div></div>
  </div>
  <div style="height:200px;background:#e5e7eb;border-radius:0.5rem;margin-bottom:1rem;"></div>
  <div style="height:0.875rem;width:6rem;background:#e5e7eb;border-radius:0.25rem;margin-bottom:0.75rem;"></div>
  <div style="border:1px solid #e5e7eb;border-radius:0.5rem;padding:0.75rem;">
    <div style="height:0.625rem;width:100%;background:#e5e7eb;border-radius:0.25rem;margin-bottom:0.5rem;"></div>
    <div style="height:0.625rem;width:60%;background:#e5e7eb;border-radius:0.25rem;"></div>
  </div>
</div>`;

export default function receiptModal() {
  return {
    modalOpen: false,
    currentId: null,
    basePath: "/admin/receipts",

    init() {
      const match = window.location.pathname.match(
        /\/receipts\/([0-9a-f-]+)/,
      );
      if (match) this.loadItem(match[1]);

      window.addEventListener("popstate", () => {
        const m = window.location.pathname.match(
          /\/receipts\/([0-9a-f-]+)/,
        );
        if (m) {
          this._fetchIntoModal(this.basePath + "/" + m[1]);
          this.currentId = m[1];
          this.modalOpen = true;
        } else {
          this.modalOpen = false;
          this.currentId = null;
        }
      });
    },

    openItem(id) {
      history.pushState(null, "", this.basePath + "/" + id);
      this.loadItem(id);
    },

    loadItem(id) {
      this.currentId = id;
      this.modalOpen = true;
      this._fetchIntoModal(this.basePath + "/" + id);
    },

    refreshModal() {
      if (this.currentId) {
        this._fetchIntoModal(this.basePath + "/" + this.currentId);
      }
    },

    closeModal() {
      this.modalOpen = false;
      this.currentId = null;
      history.pushState(null, "", this.basePath);
    },

    _fetchIntoModal(url) {
      const body = document.getElementById("modal-body");
      body.innerHTML = SKELETON;
      window.htmx.ajax("GET", url, "#modal-body");
    },
  };
}
